import {Component} from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import './FeaturedComparableMap.scss';
import './SuburbProfileMap.scss';
import propertyMarker from 'images/property_marker.png';
import {getIn} from 'lib/immutableObject';
import { getCountryCode } from 'lib/PropertyUtils';

export default class SuburbProfileMap extends Component {
  static propTypes = {
    suburb: PropTypes.string.isRequired,
    targetLatLng: PropTypes.shape({lat: PropTypes.number.isRequired, lng: PropTypes.number.isRequired}).isRequired,
    center: PropTypes.shape({lat: PropTypes.number.isRequired, lng: PropTypes.number.isRequired}),
    zoom: PropTypes.number,
    onMapZoomChange: PropTypes.func.isRequired,
    onMapCenterChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const {targetLatLng, suburb, center, zoom} = this.props;

    if (suburb && getIn(window, ['google', 'maps'])) {
      const map = this._map = new window.google.maps.Map(this._mapEl, {
        center: center,
        zoom: zoom,
        disableDefaultUI: true,
        scaleControl: true,
        zoomControl: true,
        clickableIcons: false,
      });

      if (targetLatLng) {
        this._targetMarker = new window.google.maps.Marker({
          map,
          position: targetLatLng,
          icon: {
            scaledSize: {width: 39, height: 33},
            url: propertyMarker,
          },
        });
      }

      if (!center || !zoom) {
        new window.google.maps.Geocoder().geocode({
          address: suburb,
          componentRestrictions: {
            country: getCountryCode(),
          },
        }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            map.fitBounds(results[0].geometry.viewport, {
              left: 210,
              top: 20,
              bottom: 20,
              right: 20,
            });
          }
        });
      }

      if (!center) {
        this.onZoomChanged();
        this.onCenterChanged();
      }

      window.google.maps.event.addListener(map, 'center_changed', this.onCenterChanged);
      window.google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged);
    }
  }

  componentWillUnmount() {
    if(this._map) {
      window.google.maps.event.clearInstanceListeners(this._map);
    }
  }

  onCenterChanged = debounce(() => {
    const latLng = this._map.getCenter();
    if (latLng) {
      this.props.onMapCenterChange({lat: latLng.lat(), lng: latLng.lng()});
    }
  }, 500);

  onZoomChanged = debounce(() => {
    const zoom = this._map.getZoom();
    if (zoom) {
      this.props.onMapZoomChange(zoom);
    }
  }, 500);

  render() {
    const {suburb} = this.props;

    return (
      <div className="SuburbProfileMap" ref={(ref) => this._mapEl = ref}>
        {!suburb && (
          <div className="no-data">This property contains incomplete location data</div>
        )}
      </div>
    );
  }
}
